function initSheveeHomeCards() {
  const cardsRoot = document.querySelector(
    "main[data-template='index']"
  );
  if (!cardsRoot) return;

  cardsRoot.querySelectorAll('product-card').forEach(function (card) {
    const gallery = card.querySelector('.card-gallery');
    const wishlist = card.querySelector('.Vtl-WishlistIcon__Wrapper.Vtl-CollectionCardWidget');

    if (gallery && wishlist && wishlist.parentElement !== gallery) {
      gallery.appendChild(wishlist);
    }

    if (card.dataset.sheveeCardReady === 'true') return;
    card.dataset.sheveeCardReady = 'true';

    function applySelectedColor(mediaId, variantId) {
      if (!mediaId) return;

      const slideshow = gallery && gallery.querySelector('slideshow-component');
      const sourceImage = card.querySelector('slideshow-slide[slide-id="' + mediaId + '"] img');
      const mainImage = card.querySelector('slideshow-slide img.product-media__image');

      if (slideshow && typeof slideshow.select === 'function') {
        slideshow.select({ id: mediaId }, undefined, { animate: false });
      }

      if (sourceImage && mainImage) {
        const source = sourceImage.getAttribute('src');
        const sourceSet = sourceImage.getAttribute('srcset');
        const sizes = sourceImage.getAttribute('sizes');

        if (source) mainImage.setAttribute('src', source);
        if (sourceSet) mainImage.setAttribute('srcset', sourceSet);
        if (sizes) mainImage.setAttribute('sizes', sizes);
        mainImage.setAttribute('alt', sourceImage.getAttribute('alt') || '');
      }

      const picker = card.querySelector('swatches-variant-picker-component');
      const productUrl = picker && picker.dataset.productUrl;

      if (productUrl && variantId) {
        const selectedUrl = new URL(productUrl, window.location.origin);
        selectedUrl.searchParams.set('variant', variantId);
        card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
          link.href = selectedUrl.href;
        });
      }
    }

    card.addEventListener('change', function (event) {
      const input = event.target.closest('.skims-card-swatches input[type="radio"]');
      if (!input) return;

      const mediaId = input.dataset.optionMediaId;
      const variantId = input.dataset.firstAvailableOrFirstVariantId || input.dataset.variantId;
      card.dataset.sheveeSelectedMediaId = mediaId || '';
      card.dataset.sheveeSelectedVariantId = variantId || '';

      window.requestAnimationFrame(function () {
        applySelectedColor(mediaId, variantId);
      });
      window.setTimeout(function () {
        applySelectedColor(mediaId, variantId);
      }, 500);
    });

    if (gallery) {
      gallery.addEventListener('pointerleave', function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;

        applySelectedColor(card.dataset.sheveeSelectedMediaId, card.dataset.sheveeSelectedVariantId);
      });
    }

    const initialSlide = card.querySelector('slideshow-slide[slide-id]');
    const initialInput = card.querySelector('.skims-card-swatches input[type="radio"]:checked');
    const initialMediaId = initialSlide && initialSlide.getAttribute('slide-id');
    const initialVariantId = initialInput &&
      (initialInput.dataset.firstAvailableOrFirstVariantId || initialInput.dataset.variantId);

    card.dataset.sheveeSelectedMediaId = initialMediaId || '';
    card.dataset.sheveeSelectedVariantId = initialVariantId || '';

    window.requestAnimationFrame(function () {
      applySelectedColor(initialMediaId, initialVariantId);
    });
  });
}

document.addEventListener('DOMContentLoaded', initSheveeHomeCards);
document.addEventListener('shopify:section:load', initSheveeHomeCards);

const sheveeHomeCardObserver = new MutationObserver(function () {
  window.requestAnimationFrame(initSheveeHomeCards);
});

if (document.documentElement) {
  sheveeHomeCardObserver.observe(document.documentElement, { childList: true, subtree: true });
}

window.setTimeout(initSheveeHomeCards, 500);

// Collection/search cards use a fixed image pair, independent of Horizon's
// variant slideshow. Leave always restores the currently selected colour.
function initSheveeCollectionCards() {
  document.querySelectorAll('[data-stable-card-media]').forEach(function (media) {
    const card = media.closest('product-card');
    const gallery = media.closest('.card-gallery');
    if (!card || !gallery) return;
    const wishlist = card.querySelector('.Vtl-WishlistIcon__Wrapper.Vtl-CollectionCardWidget');
    if (wishlist && wishlist.parentElement !== gallery) gallery.appendChild(wishlist);
    if (media.dataset.ready) return;
    const source = gallery.querySelector('[data-shevee-card-images]');
    if (!source) return;
    let images;
    try { images = JSON.parse(source.textContent); } catch (_) { return; }
    if (!images.length) return;
    media.dataset.ready = 'true';
    const main = media.querySelector('.shevee-stable-media__main');
    const hover = media.querySelector('.shevee-stable-media__hover');
    let revision = 0;

    // Numbered uploads of the same colour share a filename stem. With an
    // unrecognised naming scheme, retain the selected image rather than flash
    // an unrelated colour. The default state still uses upload position two.
    function groupKey(src) {
      const filename = decodeURIComponent(new URL(src, location.origin).pathname.split('/').pop());
      const match = filename.match(/^(.*?)[-_]\d+(?:_[a-f0-9-]{16,})?\.[^.]+$/i);
      return match ? match[1].toLowerCase() : null;
    }

    function configurePair(id, isInitial) {
      const primary = images.find(function (image) { return image.id === id; }) || images[0];
      const key = groupKey(primary.src);
      const secondary = isInitial ? images.find(function (image) { return image.id !== primary.id; }) :
        (key && images.find(function (image) { return image.id !== primary.id && groupKey(image.src) === key; }));
      const currentRevision = ++revision;
      media.classList.remove('is-hovering', 'hover-ready');
      media.dataset.selectedMediaId = primary.id;
      main.removeAttribute('srcset');
      main.src = primary.src;
      main.alt = primary.alt;
      if (!secondary || media.dataset.hoverEnabled !== 'true') {
        hover.removeAttribute('src');
        return;
      }
      hover.src = secondary.src;
      media.dataset.hoverMediaId = secondary.id;
      hover.decode().then(function () {
        if (revision === currentRevision) media.classList.add('hover-ready');
      }).catch(function () { /* Keep the main image if the preview cannot load. */ });
    }

    media.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'mouse') media.classList.add('is-hovering');
    });
    media.addEventListener('pointerleave', function () {
      media.classList.remove('is-hovering');
    });
    card.addEventListener('change', function (event) {
      const input = event.target.closest('.skims-card-swatches input[type="radio"]');
      if (!input) return;
      configurePair(input.dataset.optionMediaId, false);
      const variant = input.dataset.firstAvailableOrFirstVariantId || input.dataset.variantId;
      if (variant) {
        const picker = card.querySelector('swatches-variant-picker-component');
        const url = new URL(picker.dataset.productUrl, location.origin);
        url.searchParams.set('variant', variant);
        card.querySelectorAll('a[href*="/products/"]').forEach(function (link) { link.href = url.href; });
      }
    });
    configurePair(media.dataset.primaryId, true);
  });
}

document.addEventListener('DOMContentLoaded', initSheveeCollectionCards);
document.addEventListener('shopify:section:load', initSheveeCollectionCards);
const sheveeCollectionObserver = new MutationObserver(function () {
  window.requestAnimationFrame(initSheveeCollectionCards);
});
sheveeCollectionObserver.observe(document.documentElement, { childList: true, subtree: true });
initSheveeCollectionCards();
